/**
 * @desc 下拉筛选框
 * @param labelInValue?:boolean
 *    默认：true
 *    介绍：是否把每个选项的 label 包装到 value 中，会把 Select 的 value 类型从 string 变为 {key: string, label: ReactNode} 的格式
 * @param placeholder?:string
 *    默认：请输入经销商名称
 *    介绍：选择框默认文字
 * @param valueMap?: {label: string, value: string | number,}
 *    默认：{
 *      label：'userName' // 默认label取值
 *      value: 'id' // 默认value取值
 *    }
 *    介绍：数据取值
 * @param request? : {methodInterface: T.axiosPromise,beforeQuery?: (value: any) => any,listName: string,}
 *    默认：{
 *      methodInterface：API.user.queryDealerPage //请求接口
 *      beforeQuery：(value: any) => { // 请求前钩子函数 返回数据将作为接口参数传入
 *         return { name: value };
 *      },
 *      listName:'items', // 数据取值字段
 *    }
 *    介绍：数据请求配置
 */
import React from 'react';
import { Select, Spin } from 'antd';
import { setKey, getDataType } from '@/shared/functions';
import { queryDealerList } from '@/services/User';
class SelectQuery extends React.Component {
    constructor(props) {
        super(props);
        this.lastFetchId = 0;
        this.state = {
            fetching: false,
            queryList: [],
            value: undefined,
        };
        this.fetchQueryList = this.fetchQueryList.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.triggerChange = this.triggerChange.bind(this);
    }
    componentDidMount() {
        this.fetchQueryList(this.props.value);
    }
    static getDerivedStateFromProps(props) {
        return props.hasOwnProperty('value') ? {
            value: props.value,
        } : null;
    }
    fetchQueryList(val = '') {
        const { methodInterface, beforeQuery, listName } = this.props.request;
        const params = beforeQuery ? beforeQuery(val) : val;
        this.lastFetchId += 1;
        const fetchId = this.lastFetchId;
        this.setState({ data: [], fetching: true });
        methodInterface(params)
            .then((response) => {
            if (fetchId !== this.lastFetchId) {
                return;
            }
            const listData = listName ? response[listName] : response;
            if (getDataType(listData) === 'Array') {
                this.setState({ queryList: setKey(listData), fetching: false });
            }
            else {
                console.warn(`数据不符，期待为Array,实际数据为${getDataType(listData)}`);
            }
        });
    }
    triggerChange(changedValue, option) {
        const onChange = this.props.onChange;
        if (onChange) {
            onChange(changedValue, option);
        }
    }
    handleChange(value, option) {
        this.setState({
            value,
            fetching: false,
        });
        this.triggerChange(value, option);
        !value && this.fetchQueryList(value);
    }
    render() {
        const { fetching, queryList, value } = this.state;
        const { placeholder, valueMap, labelInValue } = this.props;
        return (<Select allowClear showSearch labelInValue={labelInValue} value={value} placeholder={placeholder} notFoundContent={fetching ? <Spin size={'small'}/> : <span>未搜索到相关数据</span>} filterOption={false} onSearch={this.fetchQueryList} onChange={this.handleChange} style={{ width: '100%' }} getPopupContainer={(triggerNode) => {
            return triggerNode.parentNode;
        }}>
        {queryList.map((item) => {
            return (<Select.Option value={item[valueMap.value]} key={item[valueMap.value]}>
                {item[valueMap.label]}
              </Select.Option>);
        })}
      </Select>);
    }
}
SelectQuery.defaultProps = {
    labelInValue: true,
    placeholder: '请输入经销商名称',
    valueMap: {
        label: 'userName',
        value: 'shopCode',
    },
    request: {
        methodInterface: queryDealerList,
        beforeQuery: (value) => {
            return { userName: value };
        },
    },
};
export default SelectQuery;
